
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachNavigationVue from "@/components/coach/navigation.vue";
import CoachPlayersProfileNavigationVue from "@/components/coach/players/profile/navigation.vue";
import CoachPlayersProfileRootMatchesIndexVue from "@/views/app/coach/players/profile/root/matches/index.vue";
import CoachPlayersProfileRootTrainingsIndexVue from "@/views/app/coach/players/profile/root/trainings/index.vue";
import CoachPlayersProfileRootUserInformationIndexVue from "@/views/app/coach/players/profile/root/user-information/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    CoachNavigationVue,
    CoachPlayersProfileNavigationVue,
    CoachPlayersProfileRootMatchesIndexVue,
    CoachPlayersProfileRootTrainingsIndexVue,
    CoachPlayersProfileRootUserInformationIndexVue,
  },
})
export default class CoachPlayersProfileRootIndexVue extends Vue {
}
